module.exports = __webpack_public_path__ + "static/media/omni_large.061bd01f.svg";